import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

/**
 * The CADINU husky. Site speed (2026-10-08): this was the artwork traced into five SVG paths, 207 KB of path data that
 * every page carried in its _app chunk (85 KB gzip). It now draws the same artwork from /logo.png (400x503, served with a
 * one-year cache) inside the same Svg wrapper, so width, height, spacing and spin props behave as before.
 */
const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg style={{ width: "fit-content" }} viewBox="0 0 400 503.125" width="40" height="40" {...props}>
      <image href="/logo.png" width="400" height="503.125" />
    </Svg>
  );
};

export default Icon;
